import { apiHelper } from '@/util'

export const facebookPixelService = {
  getFacebookPixels
}

//API urls
const FACEBOOK = {
  FACEBOOK: 'facebook',
  GET_PIXELS: 'get-pixel'
}

function getFacebookPixels() {
  return apiHelper().get(`${FACEBOOK.FACEBOOK}/${FACEBOOK.GET_PIXELS}`)
}
